export const USERROLES = {
  admin: "admin",
  user: "user",
};
